import React, { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  ThemeProvider,
} from "@mui/material";
import { basicTheme } from "../../themes/customTheme";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Form as JSONForm } from "@rjsf/mui"; // Assuming you have this installed
import validator from "@rjsf/validator-ajv8";
import { useSelector } from "react-redux";

import { styled } from "@mui/material/styles";

import {
  applyMandatoryForAll,
  buildUISchemaJson,
  convertQuestionsToJSON,
  convertJSONToQuestions,
} from "./utils";
import RjfsForm from "./RjfsForm";
import { ObjectFieldTemplate, ArrayFieldTemplate } from "./rjsfTemplates";
import { postFormData } from "../formManagement/formManagementAPIs";
import PublishFormModal from "../../components/formManagement/publishFormModal";
import SuccessErrorDialogBox from "../../components/reusableComponents/SuccessErrorDialogBox";
import { useLocation } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const MainGrid = styled(Grid)({
  flex: "1",
  backgroundColor: "white",
  // [theme.breakpoints.down("sm")]: {
  //   marginTop: "60px",
  // },
  marginTop: "80px",
});

const NewForm = () => {
  const location = useLocation();
  const { passed_schema } = location.state || {};

  const [jsonSchema, setJsonSchema] = useState(null);
  const [jsonSchemaForm, setJsonSchemaForm] = useState();
  const [openAddModal, setopenAddModal] = React.useState(false);
  const [projectSnackBarType, setProjectSnackBarType] = useState("success");
  const [projectSnackBarMessage, setProjectSnackBarMessage] = useState("");
  const [reload, setReload] = useState(false);
  const [openSuccessBox, setOpenSuccessBox] = useState(false);
  const [openSuccessBoxType, setOpenSuccessBoxType] = useState("success");
  const [successMessage, setSuccessMessage] = useState("");
  const [firstRender, setFirstRender] = useState(true);
  const [showRjfsForm, setShowRjfsForm] = useState(true);

  const schema = {
    type: "object",
    title: "Form Builder",
    description: "Form Builder form",
    definitions: {
      questions: {
        type: "object",
        properties: {
          choose_questions: {
            type: "string",
            title: "question",
            enum: [
              "text",
              "number",
              "single select",
              "multi-select",
              "media",
              "section",
              "dynamic-dropdown",
            ],
          },
        },
        dependencies: {
          choose_questions: {
            oneOf: [
              {
                properties: {
                  choose_questions: {
                    enum: ["text"],
                  },
                  question_title: {
                    type: "string",
                    title:
                      "Short Question Title (don't use any dots or special characters)",
                  },
                  question_heading: {
                    type: "string",
                    title: "Real Question",
                  },
                  question_required: {
                    type: "string",
                    title: "Is this question mandatory?",
                    enum: ["Yes", "No"],
                  },
                  regex: {
                    type: "string",
                    title: "Regex for the answers",
                  },
                  question_options: {
                    type: "array",
                    title: "Answer Suggestions",
                    items: {
                      type: "string",
                    },
                  },
                },
              },
              {
                properties: {
                  choose_questions: {
                    enum: ["number"],
                  },
                  question_title: {
                    type: "string",
                    title:
                      "Short Question Title (don't use any dots or special characters)",
                  },
                  question_heading: {
                    type: "string",
                    title: "Real Question",
                  },
                  question_required: {
                    type: "string",
                    title: "Is this question mandatory?",
                    enum: ["Yes", "No"],
                  },
                  question_minimum_limit: {
                    type: "number",
                    title: "Minimum Answer Accepted",
                  },
                  question_maximum_limit: {
                    type: "number",
                    title: "Maximum Answer Accepted",
                  },
                },
              },
              {
                properties: {
                  choose_questions: {
                    enum: ["media"],
                  },
                  question_title: {
                    type: "string",
                    title:
                      "Short Question Title (don't use any dots or special characters)",
                  },
                  question_heading: {
                    type: "string",
                    title: "Real Question",
                  },
                  question_media_type: {
                    type: "string",
                    title: "Select Media Type",
                    enum: ["camera", "audio", "file"],
                  },
                  question_required: {
                    type: "string",
                    title: "Is this question mandatory?",
                    enum: ["Yes", "No"],
                  },
                  question_max_files: {
                    type: "number",
                    title: "Maximum file allowed",
                  },
                  question_extra_info: {
                    type: "array",
                    title: "Add Extra Info",
                    items: {
                      type: "string",
                    },
                  },
                },
              },
              {
                properties: {
                  choose_questions: {
                    enum: ["single select"],
                  },
                  question_title: {
                    type: "string",
                    title:
                      "Short Question Title (don't use any dots or special characters)",
                  },
                  question_heading: {
                    type: "string",
                    title: "Real Question",
                  },
                  question_required: {
                    type: "string",
                    title: "Is this question mandatory?",
                    enum: ["Yes", "No"],
                  },
                  question_type: {
                    type: "string",
                    title: "Select UI version (default is radio buttons)",
                    enum: ["dropdown"],
                  },
                  question_options: {
                    type: "array",
                    title: "Add Options",
                    items: {
                      type: "string",
                    },
                  },
                },
              },
              {
                properties: {
                  choose_questions: {
                    enum: ["multi-select"],
                  },
                  question_title: {
                    type: "string",
                    title:
                      "Short Question Title (don't use any dots or special characters)",
                  },
                  question_heading: {
                    type: "string",
                    title: "Real Question",
                  },
                  question_required: {
                    type: "number",
                    title: "Minimum Option Selection",
                  },
                  question_type: {
                    type: "string",
                    title: "Select UI version (default is checkboxes)",
                    enum: ["dropdown"],
                  },
                  question_options: {
                    type: "array",
                    title: "Add Options",
                    items: {
                      type: "string",
                    },
                  },
                },
              },
              {
                properties: {
                  choose_questions: {
                    enum: ["section"],
                  },
                  section_title: {
                    type: "string",
                    title: "Section title question",
                  },
                  questions_section: {
                    type: "array",
                    title: "Question Number (Can be a section or question)",
                    items: {
                      $ref: "#/definitions/questions",
                    },
                  },
                },
              },
              {
                properties: {
                  choose_questions: {
                    enum: ["dynamic-dropdown"],
                  },
                  section_title: {
                    type: "string",
                    title: "Section title",
                  },
                  question_title: {
                    type: "string",
                    title: "Question title",
                  },
                  questions_section: {
                    type: "array",
                    title: "Question Number (Can be a section or question)",
                    items: {
                      type: "object",
                      properties: {
                        question_options: {
                          type: "array",
                          title: "Add Options",
                          items: {
                            type: "string",
                          },
                        },
                        questions: {
                          type: "array",
                          title:
                            "Question Number (Can be a section or question)",
                          items: {
                            $ref: "#/definitions/questions",
                          },
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
    properties: {
      formTitle: {
        title: "Form Title",
        type: "string",
      },
      consentSection: {
        type: "object",

        title: "Consent Section",
        properties: {
          para1: {
            type: "string",
            title: "Consent Paragraph 1",
          },
          points: {
            type: "array",
            title: "A list of points in consent",
            items: {
              type: "string",
              default: "bazinga",
            },
          },
          para2: {
            type: "string",
            title: "Consent Paragraph 2",
          },
          sections: {
            type: "array",
            title: "A list of points in section (consent)",
            items: {
              type: "object",
              properties: {
                title: {
                  type: "string",
                  title: "section title",
                },
                body: {
                  type: "string",
                  title: "section body",
                },
              },
            },
          },
          individualCheckBox: {
            type: "string",
            title: "Individual Check Box",
          },
        },
      },
      questionsSection: {
        type: "object",
        title: "Questions List",
        properties: {
          questions: {
            type: "array",
            title: "Question Number (Can be a section or question)",
            items: {
              $ref: "#/definitions/questions",
            },
          },
        },
      },
    },
  };

  const drawerWidth = useSelector(
    (state) => state.appBarSliceReducer.drawerWidth
  );
  const handleUpdateSchema = async ({ formData }) => {


    if (firstRender && passed_schema) {
      prePopulateForm(formData,passed_schema);
      setFirstRender(false)
  }

    setJsonSchema(formData);

    
  };

  const handleSubmit = async ({ formData, errors }, e) => {
    // Todo 
    handleUpdateFormSchema()
    // handler for bottom form submit button
    console.log("formData: ", formData);
  };

  const prePopulateForm =  async (formData,passed_schema) => {

    if (passed_schema) {
      // let fromPreview = await doSomethingWithSchema(formData);
      setJsonSchemaForm(passed_schema)

      formData.formTitle = passed_schema?.title;
      formData.consentSection.para1 = passed_schema?.consent?.para1;
      formData.consentSection.para2 = passed_schema?.consent?.para2;
      formData.consentSection.points = passed_schema?.consent?.points;
      formData.consentSection.sections = passed_schema?.consent?.sections;
      formData.consentSection.individualCheckBox = passed_schema?.consent.individual_consent_checkbox;
      formData.questionsSection.questions = convertJSONToQuestions(passed_schema?.properties, passed_schema.required);
      setJsonSchema(formData);
    }

  }

  const doSomethingWithSchema = async (formdata) => {
    let result = {
      type: "object",
      title: formdata?.formTitle,
      consent: {
        new_consent: true,
        para1: formdata?.consentSection?.para1,
        para2: formdata?.consentSection?.para2,
        points: formdata?.consentSection?.points,
        sections: formdata?.consentSection?.sections,
        individual_consent_checkbox:formdata?.consentSection?.individualCheckBox,
      },
      show_labels: [],
      properties: {},
      required: [],
      ui_schema: {},
    };
    let requiredQuestion = [];
    let ui_schema_array = [];
    if (formdata?.questionsSection?.questions) {
      result.properties = convertQuestionsToJSON(
        formdata.questionsSection.questions,
        requiredQuestion,
        ui_schema_array
      );
    }
    applyMandatoryForAll(result, requiredQuestion);
    result.ui_schema = buildUISchemaJson(ui_schema_array);
    console.log(result, requiredQuestion);
    return result;
  };

  const handleUpdateFormSchema = async () => {
    let someChangedSchema = await doSomethingWithSchema(jsonSchema);
    setJsonSchemaForm(someChangedSchema);
  };

  return (
    <MainGrid
      container
      id="main"
      sx={{ marginLeft: drawerWidth + "px", width: "auto" }}
      spacing={3}
    >
      <ThemeProvider theme={basicTheme}>
        <Grid
          container
          spacing={0}
          style={{ padding: 0, width: "100%", marginLeft: 80, marginRight: 0 }}
        >
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              startIcon={<ArrowForwardIcon />}
              onClick={handleUpdateFormSchema}
              sx={{ marginRight: "10px" }}
            >
              Update Schema
            </Button>
            <Button
              variant="contained"
              startIcon={<ArrowForwardIcon />}
              onClick={() => setopenAddModal(true)}
              sx={{ marginRight: "10px" }}
            >
              Publish Form to Server
            </Button>
            <Button
              variant="contained"
              startIcon={showRjfsForm ? <VisibilityOffIcon /> : <VisibilityIcon />}
              onClick={() => setShowRjfsForm(!showRjfsForm)}
            >
              {showRjfsForm ? "Hide Preview" : "Preview Form"}
            </Button>
          </Grid>
          <Grid 
            item xs={showRjfsForm ? 6 : 12} 
            sx={{ margin: showRjfsForm? '0px' :'10px' }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                width: "100%",
                height: "100vh",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Enter JSON Schema
              </Typography>
              <JSONForm
                schema={schema}
                validator={validator}
                onSubmit={handleSubmit}
                onChange={handleUpdateSchema}
                templates={{ ObjectFieldTemplate, ArrayFieldTemplate }}
              />
            </Box>
          </Grid>
          {showRjfsForm && (
            <Grid item xs={6}>
              <RjfsForm jsonSchemaForm={jsonSchemaForm} />
            </Grid>
          )}
        </Grid>
        {openSuccessBox && (
          <SuccessErrorDialogBox
            open={openSuccessBox}
            handleClose={() => setOpenSuccessBox(false)}
            text={successMessage}
            type={openSuccessBoxType}
          />
        )}
        {openAddModal && (
          <PublishFormModal
            schema={jsonSchemaForm}
            openAddModal={openAddModal}
            handleClose={() => setopenAddModal(false)}
            setProjectSnackBarMessage={setProjectSnackBarMessage}
            setProjectSnackBarType={setProjectSnackBarType}
            setReload={setReload}
            setOpenSuccessBox={setOpenSuccessBox}
            setSuccessMessage={setSuccessMessage}
            setOpenSuccessBoxType={setOpenSuccessBoxType}
          />
        )}
      </ThemeProvider>
    </MainGrid>
  );
};

export default NewForm;
